import React, { useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import BottomSheet from "../../../../../_shared/components/BottomSheet"
import useForm from "../../../../../_shared/hooks/useForm"
import UploadDropzone from "../../../../../_shared/components/FormItems/UploadDropzone"
import DocumentPreview from "../../../../../_shared/components/UploadedDocumentPreview"

// ----------------------------------------------------------------------------

function _DocumentsBottomSheet(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { document, onConfirm, onCancel, open } = props

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    const [formValues, setFormValue, setFormValues, clearFormValues] = useForm()

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        document && setFormValues(document)
        //eslint-disable-next-line
    }, [document])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleConfirm() {
        onConfirm && onConfirm(formValues)
    }

    function handleSubmit(e) {
        e.preventDefault()
    }

    function handleValueChange(field) {
        return (e) => {
            //   console.log(field, e);
            if (typeof e === "string") {
                setFormValues({ ...formValues, [field]: e })
            } else if (Array.isArray(e)) {
                setFormValues({ ...formValues, [field]: [...e] })
            } else {
                setFormValues({ ...formValues, [field]: e.target.value })
            }
        }
    }

    function handleDocUpload(docs) {
        docs && setFormValue("url", docs[0])
    }

    function handleClose() {
        clearFormValues()
        onCancel && onCancel()
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <BottomSheet
            open={open}
            className={props.className}
            onCancel={handleClose}
            onConfirm={handleConfirm}
            title={formValues?.id ? "Modifica documento" : "Crea documento"}
            snapPoint={90}
        >
            <form className="form" onSubmit={handleSubmit}>
                <UploadDropzone onUpload={handleDocUpload} type="documents" />
                {formValues?.url && (
                    <DocumentPreview
                        onChange={handleValueChange("title")}
                        doc={{
                            url:
                                typeof formValues.url === "string"
                                    ? formValues.url
                                    : URL.createObjectURL(formValues.url),
                            name: formValues?.title || "",
                        }}
                    />
                )}
            </form>
        </BottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_DocumentsBottomSheet.propTypes = {
    className: PropTypes.string.isRequired,
    document: PropTypes.any,
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
}

_DocumentsBottomSheet.defaultProps = {}

// ----------------------------------------------------------------------------

const DocumentsBottomSheet = styled(_DocumentsBottomSheet)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default DocumentsBottomSheet
